module.exports = __webpack_public_path__ + "img/USERS_SETTING.da570861.svg";